import { render, staticRenderFns } from "./mobile-endorsement.vue?vue&type=template&id=f8391ad6&scoped=true&"
import script from "./mobile-endorsement.vue?vue&type=script&lang=js&"
export * from "./mobile-endorsement.vue?vue&type=script&lang=js&"
import style0 from "./mobile-endorsement.vue?vue&type=style&index=0&id=f8391ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8391ad6",
  null
  
)

export default component.exports